import { css } from "styled-components"

const BaseCss = css`
  html {
    height: 100%;
    font-size: 100%;
  }
  body {
    background: ${props => props.theme.colors.powderWhite};
    color: ${props => props.theme.colors.light};
    font-family: ${props => props.theme.fonts.body};
    font-weight: 300;
    height: 100%;
    line-height: 1.65;
  }

  p {
    /* font-weight: 300; */
    line-height: 1.8;
    margin-bottom: 1.15rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${props => props.theme.colors.secondary};
    /* font-family: ${props => props.theme.fonts.heading}; */
    font-weight: 400;
    line-height: 1.15;
    margin: 2.75rem 0 1.05;
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.h1};
    margin-top: 0;
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.h2};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.h3};
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.h4};
  }

  h5 {
    font-size: ${props => props.theme.fontSizes.h5};
  }  

  img {
    display: block;
    /* width: 100%; */
    height: auto;
    margin: 0 auto;
  }

  figcaption {
    font-style: italic;
    margin-top: 0.25em;
    text-align: center;
  }

  a, a:visited {
    color: ${props => props.theme.colors.secondary};
    text-decoration: none;
    transition: color 0.5s;

    &:hover {
      ${props => props.theme.colors.highlight};
    }
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: bold;
  }

  blockquote {
    border-left: 3px solid ${props => props.theme.colors.highlight};
    color: ${props => props.theme.colors.opaque};
    font-size: ${props => props.theme.fontSizes.h5};
    font-style: italic;
    margin: 1em 0 1em 1em;
    padding-left: 0.5em;
  }

`

export default BaseCss
